import React, { Component } from 'react'
import '../../styles/Blog.scss'

function BlogPage () {
    return (<div id="blog">Under Development</div>)
}

export default BlogPage